import { DEFAULT_ERROR_TITLE, DEFAULT_SUCCESS_TITLE } from "constants/index";

import { useEffect } from "react";

import { AxiosError } from "axios";
import { useNotification as useNotificationReact } from "react-hook-notification";

export interface ErrorCustom {
  error: string;
  message: string;
  statusCode: number;
}

export const useNotification = (
  error?: AxiosError<unknown, any> | null | ErrorCustom | any,
  isSuccess?: boolean,
  message?: string
) => {
  const notification = useNotificationReact();
  useEffect(() => {
    if (error) {
      // eslint-disable-next-line
      let messageError = error.message.split(":")[0];
      if (error instanceof AxiosError) {
        messageError = error?.response?.data?.message;
      }
      notification.error({
        title: DEFAULT_ERROR_TITLE,
        text: messageError,
      });
    }
    if (isSuccess) {
      notification.success({
        title: DEFAULT_SUCCESS_TITLE,
        text: message ?? "",
      });
    }
  }, [error, isSuccess, message, notification]);
};
